<template>
  <span>
    <span data-test="campsite-pricing" class="display-price">{{
      formatedPrice
    }}</span>
  </span>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue'
import { useCurrencyStore } from '~/stores/useCurrencyStore'
import { formatPrice as fp } from '~/utility/formatCurrency'
import {
  MoneyRaw,
  MoneyType,
  SimpleMoney,
  priceToMoneyType,
} from '~/utility/money'

const { $i18n } = useNuxtApp()
const currencyStore = useCurrencyStore(usePinia())

const props = defineProps<{
  price: MoneyRaw | MoneyType | SimpleMoney
}>()

const formatedPrice = computed(() => {
  return fp(convertedPriceObject.value, $i18n.locale, {
    roundToMajorUnit: true,
  })
})

onMounted(() => {
  if (displayPrice.value.getCurrency() !== currencyStore.currentCurrencyCode) {
    convertDisplayPriceCurrency()
  }
})

const currencyConvertedDisplayPrice = ref<MoneyRaw | null>(null)

const currencyStoreCurrentCurrencyCode = computed(() => {
  return currencyStore.currentCurrencyCode
})

watch(currencyStoreCurrentCurrencyCode, () => {
  convertDisplayPriceCurrency()
})

function convertDisplayPriceCurrency() {
  currencyConvertedDisplayPrice.value = currencyStore
    .convert(priceMoney.value, currencyStore.currentCurrencyCode)
    .toObject()
}

const convertedPriceObject = computed(() => {
  return priceToMoneyType({
    amountMinor: Math.round(displayPriceAmount.value),
    currency: displayPriceCurrency.value,
  })
})

const displayPrice = computed(() => {
  if (currencyConvertedDisplayPrice.value) {
    return priceToMoneyType(currencyConvertedDisplayPrice.value)
  }
  return priceMoney.value
})

const displayPriceCurrency = computed(() => {
  return displayPrice.value ? displayPrice.value.getCurrency() : ''
})

const displayPriceAmount = computed(() => {
  return displayPrice.value ? displayPrice.value.getAmount() : 0
})

const priceMoney = computed(() => {
  return priceToMoneyType(props.price)
})

watch(priceMoney, () => {
  convertDisplayPriceCurrency()
})
</script>

<style scoped>
.display-price {
  font-weight: bold;
}

.converted-price {
  font-weight: normal;
}
</style>
